import React from 'react';
import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteCrop } from '@modules/editor';

const DeleteBtn: React.FC = () => {
    const dispatch = useDispatch();

    const handleDelete = () => {
        dispatch(deleteCrop());
    };

    return (
        <IconButton
            className="delete-button"
            onClick={handleDelete}
            size="small"
        >
            <DeleteIcon />
        </IconButton>
    );
};

export default DeleteBtn; 